<template>
  <div class="form-group">
    <label>Cadastro medidor eletromecânico</label>
    <div class="col-md-12">
      <div class="row align-items-start">
        <div class="col-md-9 electromechanical_meter_wrapper">
          <div v-for="(item, index) in modules" :key="index">
            <label for="" c12ass="mb-0"
              >{{ index + 1 }} - Série do lacre / Local instalado</label
            >
            <div class="row align-items-center">
              <div class="col-md-6 mb-2">
                <div class="row pl-1 pr-1">
                  <b-input
                    type="text"
                    placeholder="Série do lacre"
                    name="seal_series[]"
                    class="form-control seal_series"
                    v-model="$attrs.value.seal_series[index]"
                    v-on:input="$emit('input', $attrs.value)"
                    v-bind:value="$attrs.value.seal_series[index]"
                  />
                </div>
              </div>
              <div class="col-md-6 mb-2">
                <div class="row justify-content-between pl-1 pr-1">
                  <select
                    class="form-control installed_location"
                    placeholder="Local instalado"
                    name="installed_location[]"
                    v-model="$attrs.value.installed_location[index]"
                    v-on:input="$emit('input', $attrs.value)"
                    v-bind:value="$attrs.value.installed_location[index]"
                  >
                    <option value>Selecione o local instalado</option>
                    <option value="BD">BD</option>
                    <option value="BE">BE</option>
                    <option value="BC">BC</option>
                    <option value="CM">CM</option>
                    <option value="CF">CF</option>
                  </select>
                  <button
                    v-if="index"
                    type="button"
                    style="width: 100%"
                    @click="removeField(index)"
                    class="btn btn-danger mt-1 btn-sm "
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <button
              class="btn btn-info btn-sm"
              type="button"
              style="width: 100%"
              @click="addField"
            >
              Adicionar medidor eletromecânico
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "electromechanical-meter",
  data() {
    return {
      modules: 1,
    };
  },
  methods: {
    removeField(index) {
      this.$attrs.value.seal_series.splice(index, 1);
      this.$attrs.value.installed_location.splice(index, 1);
      this.modules--;
    },
    addField() {
      this.modules++;
    },
  },
};
</script>

<style lang="scss" scoped></style>
